import { CoreState } from '@app/store/core/states';

import { StorySettingState } from './story-setting.state';
import { StoryStepState } from './story-step-state';
import { StoryCtaTemplateState } from './story-cta-template.state';
import { StoryState } from './story.state';
import { StoryBuilderState } from './story-builder.state';
import { ContributionState } from './contribution.state';

export interface StoryFeatureState {
  story: StoryState,
  storySetting: StorySettingState,
  storyStep: StoryStepState,
  storyCtaTemplate: StoryCtaTemplateState,
  storyBuilder: StoryBuilderState,
  contribution: ContributionState
}

export interface State extends CoreState {
  story: StoryFeatureState
}